import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index'
import Luck from '@/view/luck'
import outuser from '@/view/outuser'
import aoutuser from '@/view/aoutuser'
import patrol from '@/view/patrol'
import patroldetail from '@/view/patroldetail'
import lifecycle from '@/view/lifecycle'
import Issuelog from '@/view/Issuelog'
import ledger from '@/view/ledger'
import ledgerdetail from '@/view/ledgerdetail'
import addledger from '@/view/addledger'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '导购管理'
      }
    },
    {
      path: '/luck',
      name: 'Luck',
      component: Luck,
      meta: {
        title: '抽奖'
      }
    },{
      path: '/aoutuser/:shopSid/:type',
      name: 'aoutuser',
      component: aoutuser,
      meta: {
        title: '巡查人员管理'
      }
    },{
      path: '/outuser/:shopSid',
      name: 'outuser',
      component: outuser,
      meta: {
        title: '外保人员管理'
      }
    },{
      path: '/patrol/:pointCode/:uid/:uname/:token/:type/:isuser',
      name: 'patrol',
      component: patrol,
      meta: {
        title: '巡更管理'
      }
    },{
      path: '/patroldetail/:sid/:uid/:uname/:token/:type/:periodicType/:isuser',
      name: 'patroldetail',
      component: patroldetail,
      meta: {
        title: '巡更详情'
      }
    },{
      path: '/lifecycle/:sid/:uid/:uname/:token/:button',
      name: 'lifecycle',
      component: lifecycle,
      meta: {
        title: '生命周期详情'
      }
    },{
      path: '/Issuelog/:sid/:uid/:uname/:token/:button',
      name: 'Issuelog',
      component: Issuelog,
      meta: {
        title: '问题反馈'
      }
    },{
      path: '/ledger/:token',
      name: 'ledger',
      component: ledger,
      meta: {
        title: '门店人员台账'
      }
    },{
      path: '/ledgerdetail/:id/:token',
      name: 'ledgerdetail',
      component: ledgerdetail,
      meta: {
        title: '人员信息详情'
      }
    },{
      path: '/addledger/:type',
      name: 'addledger',
      component: addledger,
      meta: {
        title: '员工信息登记'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js